// Feature flags system for enabling/disabling app features
// Controlled by admins through the Admin Control Panel

export interface FeatureFlags {
  digitalAjo: boolean;
  // Add more features here as needed in the future
  // marketBasket: boolean;
  // lightWatch: boolean;
  // etc.
}

const FEATURE_FLAGS_KEY = 'sentlo_feature_flags';

// Default feature flags - Digital Ajo is DISABLED by default
const DEFAULT_FLAGS: FeatureFlags = {
  digitalAjo: false, // Temporarily deactivated
};

/**
 * Get all feature flags
 */
export function getFeatureFlags(): FeatureFlags {
  try {
    const stored = localStorage.getItem(FEATURE_FLAGS_KEY);
    if (stored) {
      const flags = JSON.parse(stored);
      // Merge with defaults to ensure all flags exist
      return { ...DEFAULT_FLAGS, ...flags };
    }
  } catch (error) {
    console.error('Error reading feature flags:', error);
  }
  return DEFAULT_FLAGS;
}

/**
 * Update feature flags (admin only)
 */
export function setFeatureFlags(flags: Partial<FeatureFlags>): void {
  try {
    const current = getFeatureFlags();
    const updated = { ...current, ...flags };
    localStorage.setItem(FEATURE_FLAGS_KEY, JSON.stringify(updated));
    
    // Dispatch custom event to notify components of flag changes
    window.dispatchEvent(new CustomEvent('featureFlagsChanged', { detail: updated }));
  } catch (error) {
    console.error('Error saving feature flags:', error);
  }
}

/**
 * Check if a specific feature is enabled
 */
export function isFeatureEnabled(feature: keyof FeatureFlags): boolean {
  const flags = getFeatureFlags();
  return flags[feature] ?? false;
}

/**
 * Reset all feature flags to defaults
 */
export function resetFeatureFlags(): void {
  try {
    localStorage.setItem(FEATURE_FLAGS_KEY, JSON.stringify(DEFAULT_FLAGS));
    window.dispatchEvent(new CustomEvent('featureFlagsChanged', { detail: DEFAULT_FLAGS }));
  } catch (error) {
    console.error('Error resetting feature flags:', error);
  }
}
